import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

interface MergeInput {
  winnerId: string;
  loserId: string;
  /** Optional field overrides to apply to the winner before merging (e.g. cherry-picked fields from loser) */
  overrides?: Record<string, unknown>;
}

export const useVendorMerge = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ winnerId, loserId, overrides }: MergeInput) => {
      if (overrides && Object.keys(overrides).length > 0) {
        const { error: patchErr } = await (supabase
          .from("vendors") as any)
          .update(overrides)
          .eq("id", winnerId);
        if (patchErr) throw patchErr;
      }

      const { error } = await (supabase.rpc as any)("merge_vendors", {
        p_winner_id: winnerId,
        p_loser_id: loserId,
      });
      if (error) throw error;
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["vendors"] });
      qc.invalidateQueries({ queryKey: ["vendors_all_for_duplicates"] });
      qc.invalidateQueries({ queryKey: ["vendor"] });
      qc.invalidateQueries({ queryKey: ["vendor_work_orders"] });
      qc.invalidateQueries({ queryKey: ["vendor_pos"] });
      qc.invalidateQueries({ queryKey: ["vendor_bills"] });
      qc.invalidateQueries({ queryKey: ["vendor_expenses"] });
      qc.invalidateQueries({ queryKey: ["1099_summary"] });
      qc.invalidateQueries({ queryKey: ["1099_warnings"] });
    },
  });
};
